// extracted by mini-css-extract-plugin
export default {"tableBtn":"AdminStaffMgmt_tableBtn__TfFJ1","itemsButton":"AdminStaffMgmt_itemsButton__-3X1F","itemsButtonDiv":"AdminStaffMgmt_itemsButtonDiv__RNnzb"};